import {getFocusableChildren} from '../util/focus';
import {realNumberMod} from '../util/math';

export function initImageGallery() {
  let imageGalleries = document.querySelectorAll('[data-image-gallery]');

  imageGalleries.forEach(galleryEl => {
    let lightboxEl = galleryEl.querySelector('[data-image-gallery-lightbox]');
    let lightboxContentEl = galleryEl.querySelector('[data-image-gallery-lightbox-content]');
    let openGalleryTrigger = galleryEl.querySelector('[data-image-gallery-lightbox-trigger]');
    let closeGalleryTrigger = galleryEl.querySelector('[data-image-gallery-lightbox-close-trigger]');
    let lightboxBgEl = galleryEl.querySelector('[data-image-gallery-lightbox-bg]');
    let bodyEl = document.querySelector('html');

    if (!lightboxEl || !lightboxContentEl || !openGalleryTrigger || !closeGalleryTrigger || !lightboxBgEl) {
      return;
    }

    function isOpen() {
      return !lightboxEl.classList.contains('hidden');
    }

    let previousFocus;

    function open() {
      if (isOpen()) {
        return;
      }

      lightboxEl.classList.remove('hidden');
      bodyEl.classList.add('kg-blocks-lightbox-body-overflow-lock');

      previousFocus = document.activeElement;
      const focusableChildren = getFocusableChildren(lightboxContentEl);

      if (focusableChildren.length > 0) {
        focusableChildren[0].focus();
      } else {
        lightboxContentEl.focus();
      }
    }

    function close() {
      if (!isOpen()) {
        return;
      }

      lightboxEl.classList.add('hidden');
      bodyEl.classList.remove('kg-blocks-lightbox-body-overflow-lock');

      if (previousFocus) {
        previousFocus.focus();
      }
    }

    function toggle() {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    }

    openGalleryTrigger.addEventListener('click', toggle);
    closeGalleryTrigger.addEventListener('click', close);
    lightboxBgEl.addEventListener('click', (e) => {
      e.stopPropagation();
      close();
    });
    document.body.addEventListener('keydown', (e) => {
      if (!isOpen()) {
        return;
      }

      if (e.key === 'Escape') {
        close();
      } else if (e.key === 'Tab') {
        const focusableElements = getFocusableChildren(lightboxEl);
        let currentIndex = focusableElements.indexOf(document.activeElement);

        if (currentIndex === -1) {
          return;
        }

        e.preventDefault();

        currentIndex += e.shiftKey ? -1 : 1;
        currentIndex = realNumberMod(currentIndex, focusableElements.length);

        focusableElements[currentIndex].focus();
      }
    });
  });
}
